import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.query<MinimalTournamentsResponse, { status: TournamentsStatus }>({
    query: ({ status }) => ({
      url: `v4/pitch-owner/tournaments/fetch?status=${status}`,
      method: 'Get',
    }),
  });

export enum TournamentsStatus {
  ACTIVE = 'active',
  DEACTIVATED = 'deactivated',
}

export interface MinimalTournamentsResponse {
  data: MinimalTournament[];
}

export interface MinimalTournament {
  id: number;
  name: string;
  name_ar: string;
}
